/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCompareText } from '../../factoriesAny.js';
export var compareTextDependencies = {
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createCompareText: createCompareText
};